import { BaseMatcher, Matcher } from './base.matcher';

export function containsText(
  value: string | null | undefined,
  message: () => string = () => 'array must have text',
): Matcher<Array<string>> {
  return new BaseMatcher<Array<string>>((items) => !!value && items.includes(value), message);
}
